import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from "@mui/material";

const ApprovalModal = ({ open, onClose, onSubmit }) => {
  const [approvalReason, setApprovalReason] = useState("");

  const handleSubmit = () => {
    if (!approvalReason.trim()) {
      return;
    }
    onSubmit(approvalReason);
    setApprovalReason("");
    onClose();
  };
  const handleCancel = () => {
    setApprovalReason("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel}>
      <DialogContent>
        <label className="my-2">Approval Reason:</label>
        <TextField
          autoFocus
          margin="dense"
          label="Enter Reason"
          type="text"
          fullWidth
          value={approvalReason}
          onChange={(e) => setApprovalReason(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="secondary">
          {`Close`}
        </Button>
        <Button
          onClick={handleSubmit}
          color="success"
          disabled={!approvalReason.trim()}
        >
          {`Approve`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApprovalModal;
